var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58886 0 0 3.58886 0 8C0 12.4111 3.58886 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58886 12.4111 0 8 0ZM8.09295 12.8226L8.09277 12.8226L8.09272 12.8226C7.71668 12.8927 7.26786 12.9764 7.00005 12.9986C6.67498 13.0255 6.36821 12.8394 6.18121 12.5723C5.99373 12.3052 5.9488 11.9634 6.06011 11.6568L7.57231 7.49859H6.00004C5.9987 6.63214 6.64861 5.99505 7.47984 5.75055C7.87651 5.63384 8.61557 5.47413 9.00004 5.4986C9.23038 5.51325 9.63187 5.65777 9.81887 5.92489C10.0064 6.19197 10.0513 6.53377 9.93998 6.84041L8.42777 10.9986H9.99956C9.99986 11.864 9.37419 12.6029 8.52044 12.7452C8.40546 12.7643 8.25606 12.7922 8.09295 12.8226ZM8 4.00001C8 4.55225 8.44771 5.00002 9.00001 5.00002C9.55234 5.00002 10 4.55228 10 4.00001C10 3.44771 9.55231 3 9.00001 3C8.44771 3 8 3.44771 8 4.00001Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfoIcon);
export default ForwardRef;